<template>
    <router-view/>
</template>
<script>
export default {
    name: 'PaymentPage',
    data: () => ({
    })
}
</script>